export default class ViewBump {

	constructor(x, y, parent) {
		this.x = x;
		this.y = y;
		this.parent = parent;
	}
	clone() {
		return new ViewBump(this.x, this.y, this.parent ? this.parent.clone() : undefined);
	}
}